<script setup lang="ts">
  import type { PropType } from 'vue';

  type Category = {
    title: string;
    photo: string;
  }

  defineOptions({
    inheritAttrs: false,
  });

  defineProps({
    header: String,
    header_type: String,
    categories: { type: Array as PropType<Category[]>, required: true },
  });
</script>
<template>
  <Segment :title="header" :headerType="header_type" :class="{'segment--empty-title': !header}">
    <CategoriesCarousel :categories />
  </Segment>
</template>
<style scoped lang="scss">

  .segment--empty-title > :deep(.container) > .segment__content {
    margin-top: 0;
  }

  @media(min-width: 993px) {
    .segment {
      padding: 80px 0;
    }
  }

  @media(max-width: 992px) {
    .segment {
      padding-right: 0;
    }
  }
</style>
